"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _elementIcons = _interopRequireDefault(require("../js/element-icons"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var _default = exports.default = {
  name: 'iconFrom',
  data: function data() {
    return {
      elementIcons: _elementIcons.default,
      iconVal: '',
      modals2: false,
      list: []
    };
  },
  mounted: function mounted() {
    this.list = this.elementIcons;
  },
  methods: {
    generateElementIconCode: function generateElementIconCode(symbol) {
      return "<i class=\"el-icon-".concat(symbol, "\" />");
    },
    handleClipboard: function handleClipboard(text, event, n) {
      this.iconChange(n);
      //  clipboard(text, event)
    },
    // 搜索
    upIcon: function upIcon(n) {
      var arrs = [];
      for (var i = 0; i < this.elementIcons.length; i++) {
        if (this.elementIcons[i].indexOf(n) !== -1) {
          arrs.push(this.elementIcons[i]);
          this.list = arrs;
        }
      }
    },
    iconChange: function iconChange(n) {
      this.$emit('getIcon', n);
      this.$msgbox.close();
    }
  }
};